// escapeHtml — the mandatory FIRST step before any markdown-to-HTML tag
// injection. The text being rendered is AI output derived from
// attacker-supplied uploaded documents (contracts/correspondence/etc.), so a
// clause like `<img src=x onerror=…>` must render as inert text, not an
// executing tag. Every renderer that builds HTML strings (or feeds
// dangerouslySetInnerHTML) must escape with this before injecting any of its
// own known-safe tags — do not re-implement the escape chain locally.
export function escapeHtml(str) {
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}
